export default __webpack_public_path__ + "static/media/demand.c550b823.svg";